export const ActionTypes = {
  FETCH_MAINTENANCE_PARTS: 'services/maintenance/fetch_maintenance_parts',
  SET_MAINTENANCE_PARTS: 'services/maintenance/set_maintenance_parts',
  SET_MAINTENANCE_PARTS_LOADER_STATUS: 'services/maintenance/set_maintenance_parts_loader_status',
  ADD_UPDATE_MAINTENANCE_PARTS: 'services/maintenance/add_update_maintenance_parts',
  DELETE_MAINTENANCE_PARTS: 'services/maintenance/delete_maintenance_parts',

  FETCH_MAINTENANCE_PART_TYPES: 'services/maintenance/fetch_maintenance_part_types',
  SET_MAINTENANCE_PART_TYPES: 'services/maintenance/set_maintenance_part_types',
  FETCH_MAINTENANCE_PART_TYPES_SEARCHED: 'services/maintenance/fetch_maintenance_part_types_searched',
  SET_MAINTENANCE_PART_TYPES_SEARCHED: 'services/maintenance/set_maintenance_part_types_searched',
  ADD_UPDATE_MAINTENANCE_PART_TYPES: 'services/maintenance/add_update_maintenance_part_types',
  DELETE_MAINTENANCE_PART_TYPES: 'services/maintenance/delete_maintenance_part_types',
  SET_MAINTENANCE_PART_TYPES_SEARCHED_LOADER_STATUS:
    'services/maintenance/set_maintenance_part_types_searched_loader_status',

  FETCH_MAINTENANCE_TYPES_SEARCHED: 'services/maintenance/fetch_maintenance_types_searched',
  SET_MAINTENANCE_TYPES_SEARCHED: 'services/maintenance/set_maintenance_types_searched',
  ADD_UPDATE_MAINTENANCE_TYPES: 'services/maintenance/add_update_maintenance_types',
  DELETE_MAINTENANCE_TYPES: 'services/maintenance/delete_maintenance_types',
  SET_MAINTENANCE_TYPES_SEARCHED_LOADER_STATUS: 'services/maintenance/set_maintenance_types_searched_loader_status',

  FETCH_MAINTENANCE_REASON_SEARCHED: 'services/maintenance/fetch_maintenance_reason_searched',
  SET_MAINTENANCE_REASON_SEARCHED: 'services/maintenance/set_maintenance_reason_searched',
  ADD_UPDATE_MAINTENANCE_REASON: 'services/maintenance/add_update_maintenance_reason',
  DELETE_MAINTENANCE_REASON: 'services/maintenance/delete_maintenance_reason',
  SET_MAINTENANCE_REASON_SEARCHED_LOADER_STATUS: 'services/maintenance/set_maintenance_reason_searched_loader_status',

  FETCH_MAINTENANCE_STATUS_SEARCHED: 'services/maintenance/fetch_maintenance_status_searched',
  SET_MAINTENANCE_STATUS_SEARCHED: 'services/maintenance/set_maintenance_status_searched',
  ADD_UPDATE_MAINTENANCE_STATUS: 'services/maintenance/add_update_maintenance_status',
  DELETE_MAINTENANCE_STATUS: 'services/maintenance/delete_maintenance_status',
  SET_MAINTENANCE_STATUS_SEARCHED_LOADER_STATUS: 'services/maintenance/set_maintenance_status_searched_loader_status',

  FETCH_MAINTENANCE_JOB_HISTORY: 'services/maintenance/fetch_maintenance_job_history',
  EXPORT_MAINTENANCE_JOB_HISTORY_LOADER: 'services/maintenance/fetch_export_maintenance_job_history',
  EXPORT_MAINTENANCE_JOB_HISTORY: 'services/maintenance/export_maintenance_job_history',
  SET_EXPORT_MAINTENANCE_JOB_HISTORY: 'services/maintenance/set_export_maintenance_job_history',
  SET_MAINTENANCE_JOB_HISTORY: 'services/maintenance/set_maintenance_job_history',
  SET_MAINTENANCE_JOB_HISTORY_LOADER_STATUS: 'services/maintenance/set_maintenance_job_history_loader_status',
  ADD_UPDATE_MAINTENANCE_JOB_HISTORY: 'services/maintenance/add_update_maintenance_job_history',
  DELETE_MAINTENANCE_JOB_HISTORY: 'services/maintenance/delete_maintenance_job_history',
  FETCH_MAINTENANCE_IMAGES_BY_JOB: 'services/maintenance/fetch_maintenance_images_by_job',
  SET_MAINTENANCE_IMAGES_BY_JOB: 'services/maintenance/set_maintenance_images_by_job',
  SET_MAINTENANCE_IMAGES_BY_JOB_LOADER_STATUS: 'services/maintenance/set_maintenance_images_by_job_loader_status',
  FETCH_MAINTENANCE_RECURRENCE_JOBS: 'services/maintenance/fetch_maintenance_recurrence_jobs',
  SET_MAINTENANCE_RECURRENCE_JOBS: 'services/maintenance/set_maintenance_recurrence_jobs',
  SET_MAINTENANCE_RECURRENCE_JOBS_LOADER_STATUS: 'services/maintenance/set_maintenance_recurrence_jobs_loader_status',
  ADD_UPDATE_MAINTENANCE_RECURRENCE_JOB: 'services/maintenance/add_update_maintenance_recurrence_job',
  DELETE_MAINTENANCE_RECURRENCE_JOB: 'services/maintenance/delete_maintenance_recurrence_job',

  FETCH_MAINTENANCE_RECURRENCE_INSTANCES: 'services/maintenance/fetch_maintenance_recurrence_instances',
  SET_MAINTENANCE_RECURRENCE_INSTANCES: 'services/maintenance/set_maintenance_recurrence_instances',
  SET_MAINTENANCE_RECURRENCE_INSTANCES_LOADER_STATUS:
    'services/maintenance/set_maintenance_recurrence_instances_loader_status',
  ADD_UPDATE_MAINTENANCE_RECURRENCE_INSTANCE: 'services/maintenance/add_update_maintenance_recurrence_instance',
  DELETE_MAINTENANCE_RECURRENCE_INSTANCE: 'services/maintenance/delete_maintenance_recurrence_instance',

  SET_MAINTENANCE_JOB_FILTER: 'services/productionOperation/set_maintenance_job_filter',
};

// maintenance Parts
const fetchMaintenanceParts = ({ maintenancePartsParams }) => ({
  maintenancePartsParams,
  type: ActionTypes.FETCH_MAINTENANCE_PARTS,
});

const setMaintenanceParts = ({ maintenancePartsData }) => ({
  maintenancePartsData,
  type: ActionTypes.SET_MAINTENANCE_PARTS,
});

const addUpdateMaintenanceParts = ({ actionName, maintenancePartsObj, maintenancePartsParams }) => ({
  actionName,
  maintenancePartsObj,
  maintenancePartsParams,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_PARTS,
});

const deleteMaintenanceParts = ({ partId, maintenancePartsParams }) => ({
  partId,
  maintenancePartsParams,
  type: ActionTypes.DELETE_MAINTENANCE_PARTS,
});

const setMaintenancePartLoader = ({ maintenancePartsLoader }) => ({
  maintenancePartsLoader,
  type: ActionTypes.SET_MAINTENANCE_PARTS_LOADER_STATUS,
});

// part Types
const fetchMaintenancePartTypes = () => ({
  type: ActionTypes.FETCH_MAINTENANCE_PART_TYPES,
});

const setMaintenancePartTypes = ({ maintenancePartTypesData }) => ({
  maintenancePartTypesData,
  type: ActionTypes.SET_MAINTENANCE_PART_TYPES,
});

const fetchMaintenancePartTypesSearched = ({ maintenancePartTypesParams }) => ({
  maintenancePartTypesParams,
  type: ActionTypes.FETCH_MAINTENANCE_PART_TYPES_SEARCHED,
});

const setMaintenancePartTypesSearched = ({ maintenancePartTypesSearchedData }) => ({
  maintenancePartTypesSearchedData,
  type: ActionTypes.SET_MAINTENANCE_PART_TYPES_SEARCHED,
});

const addUpdateMaintenancePartTypes = ({ actionName, maintenancePartTypesObj, maintenancePartTypesParams }) => ({
  actionName,
  maintenancePartTypesObj,
  maintenancePartTypesParams,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_PART_TYPES,
});

const deleteMaintenancePartTypes = ({ partTypeId, maintenancePartTypesParams }) => ({
  partTypeId,
  maintenancePartTypesParams,
  type: ActionTypes.DELETE_MAINTENANCE_PART_TYPES,
});

const setMaintenancePartTypesSearchedLoader = ({ maintenancePartTypesSearchedLoader }) => ({
  maintenancePartTypesSearchedLoader,
  type: ActionTypes.SET_MAINTENANCE_PART_TYPES_SEARCHED_LOADER_STATUS,
});

// Maintenance Types
const fetchMaintenanceTypesSearched = ({ maintenanceTypesParams }) => ({
  maintenanceTypesParams,
  type: ActionTypes.FETCH_MAINTENANCE_TYPES_SEARCHED,
});

const setMaintenanceTypesSearched = ({ maintenanceTypesSearchedData }) => ({
  maintenanceTypesSearchedData,
  type: ActionTypes.SET_MAINTENANCE_TYPES_SEARCHED,
});

const addUpdateMaintenanceTypes = ({ actionName, maintenanceTypesObj, maintenanceTypesParams }) => ({
  actionName,
  maintenanceTypesObj,
  maintenanceTypesParams,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_TYPES,
});

const deleteMaintenanceTypes = ({ typeId, maintenanceTypesParams }) => ({
  typeId,
  maintenanceTypesParams,
  type: ActionTypes.DELETE_MAINTENANCE_TYPES,
});

const setMaintenanceTypesSearchedLoader = ({ maintenanceTypesSearchedLoader }) => ({
  maintenanceTypesSearchedLoader,
  type: ActionTypes.SET_MAINTENANCE_TYPES_SEARCHED_LOADER_STATUS,
});

// Maintenance Reason
const fetchMaintenanceReasonSearched = ({ maintenanceReasonParams }) => ({
  maintenanceReasonParams,
  type: ActionTypes.FETCH_MAINTENANCE_REASON_SEARCHED,
});

const setMaintenanceReasonSearched = ({ maintenanceReasonSearchedData }) => ({
  maintenanceReasonSearchedData,
  type: ActionTypes.SET_MAINTENANCE_REASON_SEARCHED,
});

const addUpdateMaintenanceReason = ({ actionName, maintenanceReasonObj, maintenanceReasonParams }) => ({
  actionName,
  maintenanceReasonObj,
  maintenanceReasonParams,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_REASON,
});

const deleteMaintenanceReason = ({ reasonId, maintenanceReasonParams }) => ({
  reasonId,
  maintenanceReasonParams,
  type: ActionTypes.DELETE_MAINTENANCE_REASON,
});

const setMaintenanceReasonSearchedLoader = ({ maintenanceReasonSearchedLoader }) => ({
  maintenanceReasonSearchedLoader,
  type: ActionTypes.SET_MAINTENANCE_REASON_SEARCHED_LOADER_STATUS,
});

// Maintenance Status
const fetchMaintenanceStatusSearched = ({ maintenanceStatusParams }) => ({
  maintenanceStatusParams,
  type: ActionTypes.FETCH_MAINTENANCE_STATUS_SEARCHED,
});

const setMaintenanceStatusSearched = ({ maintenanceStatusSearchedData }) => ({
  maintenanceStatusSearchedData,
  type: ActionTypes.SET_MAINTENANCE_STATUS_SEARCHED,
});

const addUpdateMaintenanceStatus = ({ actionName, maintenanceStatusObj, maintenanceStatusParams }) => ({
  actionName,
  maintenanceStatusObj,
  maintenanceStatusParams,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_STATUS,
});

const deleteMaintenanceStatus = ({ statusId, maintenanceStatusParams }) => ({
  statusId,
  maintenanceStatusParams,
  type: ActionTypes.DELETE_MAINTENANCE_STATUS,
});

const setMaintenanceStatusSearchedLoader = ({ maintenanceStatusSearchedLoader }) => ({
  maintenanceStatusSearchedLoader,
  type: ActionTypes.SET_MAINTENANCE_STATUS_SEARCHED_LOADER_STATUS,
});

// maintenance Job History

const fetchMaintenanceJobHistoryData = ({ maintenanceJobHistoryParams }) => ({
  maintenanceJobHistoryParams,
  type: ActionTypes.FETCH_MAINTENANCE_JOB_HISTORY,
});

// export mantenance job data
const maintenanceJobHistoryDataExportLoader = ({ maintenanceJobHistoryExportLoader }) => ({
  maintenanceJobHistoryExportLoader,
  type: ActionTypes.EXPORT_MAINTENANCE_JOB_HISTORY_LOADER,
});

const maintenanceJobHistoryDataExport = () => ({
  type: ActionTypes.EXPORT_MAINTENANCE_JOB_HISTORY,
});

const setMaintenanceJobHistoryDataExport = ({ maintenanceJobHistoryExportData }) => ({
  maintenanceJobHistoryExportData,
  type: ActionTypes.SET_EXPORT_MAINTENANCE_JOB_HISTORY,
}); // end export maintenance job data

const setMaintenanceJobHistoryData = ({ maintenanceJobHistoryData }) => ({
  maintenanceJobHistoryData,
  type: ActionTypes.SET_MAINTENANCE_JOB_HISTORY,
});

const addUpdateMaintenanceJobHistory = ({
  actionName,
  maintenanceJob,
  maintenanceJobHistoryParams,
  maintenanceImages,
}) => ({
  actionName,
  maintenanceJob,
  maintenanceJobHistoryParams,
  maintenanceImages,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_JOB_HISTORY,
});

const deleteMaintenanceJobHistory = ({ maintenanceObj, maintenanceJobHistoryParams }) => ({
  maintenanceObj,
  maintenanceJobHistoryParams,
  type: ActionTypes.DELETE_MAINTENANCE_JOB_HISTORY,
});

const fetchMaintenanceImagesByJob = ({ jobId }) => ({
  jobId,
  type: ActionTypes.FETCH_MAINTENANCE_IMAGES_BY_JOB,
});

const setMaintenanceImagesByJob = ({ maintenanceImagesListData }) => ({
  maintenanceImagesListData,
  type: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB,
});

const setMaintenanceImagesByJobLoaderStatus = ({ maintenanceImageLoader }) => ({
  maintenanceImageLoader,
  type: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB_LOADER_STATUS,
});

const setMaintenanceJobHistoryLoader = ({ maintenanceJobHistoryLoader }) => ({
  maintenanceJobHistoryLoader,
  type: ActionTypes.SET_MAINTENANCE_JOB_HISTORY_LOADER_STATUS,
});

// maintenance Recurrence Jobs
const fetchMaintenanceRecurrenceJobs = ({ maintenanceRecurrenceJobsParams }) => ({
  maintenanceRecurrenceJobsParams,
  type: ActionTypes.FETCH_MAINTENANCE_RECURRENCE_JOBS,
});

const setMaintenanceRecurrenceJobsData = ({ maintenanceRecurrenceJobsData }) => ({
  maintenanceRecurrenceJobsData,
  type: ActionTypes.SET_MAINTENANCE_RECURRENCE_JOBS,
});

const addUpdateMaintenanceRecurrenceJob = ({
  actionName,
  recurringMaintenanceObj,
  maintenanceRecurrenceJobsParams,
}) => ({
  actionName,
  recurringMaintenanceObj,
  maintenanceRecurrenceJobsParams,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_RECURRENCE_JOB,
});

const deleteMaintenanceRecurrenceJob = ({ recurringJobId, maintenanceRecurrenceJobsParams }) => ({
  recurringJobId,
  maintenanceRecurrenceJobsParams,
  type: ActionTypes.DELETE_MAINTENANCE_RECURRENCE_JOB,
});

const setMaintenanceRecurrenceJobsLoader = ({ maintenanceRecurrenceJobsLoader }) => ({
  maintenanceRecurrenceJobsLoader,
  type: ActionTypes.SET_MAINTENANCE_RECURRENCE_JOBS_LOADER_STATUS,
});

// maintenance Recurrence Instances
const fetchMaintenanceRecurrenceInstances = ({ recurrenceInstanceParams }) => ({
  recurrenceInstanceParams,
  type: ActionTypes.FETCH_MAINTENANCE_RECURRENCE_INSTANCES,
});

const setMaintenanceRecurrenceInstancesData = ({ recurrenceInstanceData }) => ({
  recurrenceInstanceData,
  type: ActionTypes.SET_MAINTENANCE_RECURRENCE_INSTANCES,
});

const addUpdateMaintenanceRecurrenceInstance = ({ actionName, recurrenceInstanceObj, recurrenceInstanceParams }) => ({
  actionName,
  recurrenceInstanceObj,
  recurrenceInstanceParams,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_RECURRENCE_INSTANCE,
});

const deleteMaintenanceRecurrenceInstance = ({ recurringInstanceId, recurrenceInstanceParams }) => ({
  recurringInstanceId,
  recurrenceInstanceParams,
  type: ActionTypes.DELETE_MAINTENANCE_RECURRENCE_INSTANCE,
});

const setMaintenanceRecurrenceInstancesLoader = ({ recurrenceInstanceLoader }) => ({
  recurrenceInstanceLoader,
  type: ActionTypes.SET_MAINTENANCE_RECURRENCE_INSTANCES_LOADER_STATUS,
});

// Filters
const setMaintenanceJobFilter = ({ addMaintenanceJob }) => ({
  addMaintenanceJob,
  type: ActionTypes.SET_MAINTENANCE_JOB_FILTER,
});

export default {
  fetchMaintenanceParts,
  setMaintenanceParts,
  setMaintenancePartLoader,
  addUpdateMaintenanceParts,
  deleteMaintenanceParts,

  fetchMaintenancePartTypes,
  setMaintenancePartTypes,
  fetchMaintenancePartTypesSearched,
  setMaintenancePartTypesSearched,
  setMaintenancePartTypesSearchedLoader,
  addUpdateMaintenancePartTypes,
  deleteMaintenancePartTypes,

  fetchMaintenanceTypesSearched,
  setMaintenanceTypesSearched,
  setMaintenanceTypesSearchedLoader,
  addUpdateMaintenanceTypes,
  deleteMaintenanceTypes,

  fetchMaintenanceReasonSearched,
  setMaintenanceReasonSearched,
  addUpdateMaintenanceReason,
  deleteMaintenanceReason,
  setMaintenanceReasonSearchedLoader,

  fetchMaintenanceStatusSearched,
  setMaintenanceStatusSearched,
  addUpdateMaintenanceStatus,
  deleteMaintenanceStatus,
  setMaintenanceStatusSearchedLoader,

  fetchMaintenanceJobHistoryData,
  maintenanceJobHistoryDataExportLoader,
  setMaintenanceJobHistoryDataExport,
  maintenanceJobHistoryDataExport,
  setMaintenanceJobHistoryData,
  addUpdateMaintenanceJobHistory,
  deleteMaintenanceJobHistory,
  fetchMaintenanceImagesByJob,
  setMaintenanceImagesByJob,
  setMaintenanceImagesByJobLoaderStatus,
  setMaintenanceJobHistoryLoader,

  fetchMaintenanceRecurrenceJobs,
  setMaintenanceRecurrenceJobsData,
  addUpdateMaintenanceRecurrenceJob,
  deleteMaintenanceRecurrenceJob,
  setMaintenanceRecurrenceJobsLoader,

  fetchMaintenanceRecurrenceInstances,
  setMaintenanceRecurrenceInstancesData,
  addUpdateMaintenanceRecurrenceInstance,
  deleteMaintenanceRecurrenceInstance,
  setMaintenanceRecurrenceInstancesLoader,

  setMaintenanceJobFilter,
};
